import {
    ISeriesPrimitivePaneRenderer,
    ISeriesPrimitivePaneView,
    SeriesPrimitivePaneViewZOrder
} from 'lightweight-charts'
import LabelledVerticalLineDrawing from './labelledVerticalLine.drawing'
import VerticalLinePaneRenderer from './labelledVerticalLine.paneRenderer'

class LabelledVerticalLinePaneView implements ISeriesPrimitivePaneView {
    drawing: LabelledVerticalLineDrawing
    paneRenderer: VerticalLinePaneRenderer;

    constructor(drawing: LabelledVerticalLineDrawing) {
        this.drawing = drawing;
        this.paneRenderer = new VerticalLinePaneRenderer(this.drawing);
    }

    zOrder(): SeriesPrimitivePaneViewZOrder {
        return 'top'
    }

    renderer(): ISeriesPrimitivePaneRenderer | null {
        return this.paneRenderer
    }
    destroy() {
        this.paneRenderer.destroy();
        this.paneRenderer = null;
    }
}


export default LabelledVerticalLinePaneView